<template>
    <DeviceCheck title="Speaker Check" question="Can you hear the sound?" :devices="devices" device-name="Speaker"
        v-bind="$attrs" @deviceChange="onDeviceChange">
        <div class="speaker-icon"><i class="fa fa-volume-high"></i></div>
    </DeviceCheck>
</template>

<script setup>

import { onMounted, onUnmounted, toRef } from 'vue';
import DeviceCheck from "./DeviceCheck.vue";
import robotSound from "@/assets/sounds/robotSound.wav";
import { useSoundPlayer } from "@/composables/useSoundPlayer";

const emit = defineEmits(['speakerChange']);
const props = defineProps(['devices']);
const devicesRef = toRef(props, 'devices');

const soundPlayer = useSoundPlayer({
    sound: robotSound,
    loop: true,
    devices: devicesRef
});

onMounted(() => {
    soundPlayer.start();
});

onUnmounted(() => {
    soundPlayer.end();
});

function onDeviceChange(deviceId) {
    soundPlayer.setAudioSpeaker(deviceId);
    emit('speakerChange', deviceId);
}

</script>

<style lang="scss" scoped>
.speaker-icon {
    font-size: 10vh;
    opacity: 0.5;
}
</style>
